import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "all-icons"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 0,
  class: "icon-wrap"
};
const _hoisted_4 = {
  key: 1,
  class: "icon-wrap"
};
import { Clock, VideoPlay, SuccessFilled, CircleCloseFilled, WarningFilled, QuestionFilled } from '@element-plus/icons-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'manual-test-status-icon',
  props: {
    status: {
      default: 999
    },
    allIcons: {
      type: Boolean,
      default: false
    },
    type: {
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _ctx.allIcons ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Clock))]),
        _: 1
      }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "Initialize", -1)), _createVNode(_component_el_icon, {
        color: "#abc233"
      }, {
        default: _withCtx(() => [_createVNode(_unref(VideoPlay))]),
        _: 1
      }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "Running", -1)), _createVNode(_component_el_icon, {
        color: "#6cc04a"
      }, {
        default: _withCtx(() => [_createVNode(_unref(SuccessFilled))]),
        _: 1
      }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "Finish", -1)), _createVNode(_component_el_icon, {
        color: "#cf2030"
      }, {
        default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
        _: 1
      }), _cache[3] || (_cache[3] = _createElementVNode("span", null, "Fail", -1)), _createVNode(_component_el_icon, {
        color: "#ec0e7a"
      }, {
        default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
        _: 1
      }), _cache[4] || (_cache[4] = _createElementVNode("span", null, "Error", -1)), _createVNode(_component_el_icon, {
        color: "#c5c5c5"
      }, {
        default: _withCtx(() => [_createVNode(_unref(QuestionFilled))]),
        _: 1
      }), _cache[5] || (_cache[5] = _createElementVNode("span", null, "Unknown", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_ctx.type === 'currentManualTestStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_ctx.status === 0 ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        content: "Running",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#abc233"
        }, {
          default: _withCtx(() => [_createVNode(_unref(VideoPlay))]),
          _: 1
        })]),
        _: 1
      })) : _ctx.status === 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 1,
        content: "Finish",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#6cc04a"
        }, {
          default: _withCtx(() => [_createVNode(_unref(SuccessFilled))]),
          _: 1
        })]),
        _: 1
      })) : _ctx.status === -1 || _ctx.status > 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 2,
        content: "Fail",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#cf2030"
        }, {
          default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
          _: 1
        })]),
        _: 1
      })) : [-2, -3].includes(_ctx.status) ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 3,
        content: "Error",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#ec0e7a"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 4,
        content: "Unknown",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#c5c5c5"
        }, {
          default: _withCtx(() => [_createVNode(_unref(QuestionFilled))]),
          _: 1
        })]),
        _: 1
      }))])) : ['manualTestList', 'manualTestListHistory'].includes(_ctx.type) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_ctx.status === 0 ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        content: "Initialize",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16
        }, {
          default: _withCtx(() => [_createVNode(_unref(Clock))]),
          _: 1
        })]),
        _: 1
      })) : _ctx.status === 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 1,
        content: "Running",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#abc233"
        }, {
          default: _withCtx(() => [_createVNode(_unref(VideoPlay))]),
          _: 1
        })]),
        _: 1
      })) : _ctx.status === 2 ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 2,
        content: "Finish",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#6cc04a"
        }, {
          default: _withCtx(() => [_createVNode(_unref(SuccessFilled))]),
          _: 1
        })]),
        _: 1
      })) : [-1, 3].includes(_ctx.status) ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 3,
        content: "Fail",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#cf2030"
        }, {
          default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
          _: 1
        })]),
        _: 1
      })) : [-2, 4].includes(_ctx.status) ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 4,
        content: "Error",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#ec0e7a"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })]),
        _: 1
      })) : _ctx.status === 999 ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 5,
        content: "Unknown",
        placement: "top",
        effect: "light"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 16,
          color: "#c5c5c5"
        }, {
          default: _withCtx(() => [_createVNode(_unref(QuestionFilled))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]));
    };
  }
});